export enum EForm {
  firstName = 'firstName',
  lastName = 'lastName',
  number = 'number',
  email = 'email',
  website = 'website',
};

export const LeadFormParameters = {
  benefits: {
    pageTitle: 'Benefits',
    formUrl: 'https://www.df-alliance.com/benefits',
    leadSubtype: 'Benefit',
  },
  shippingLeads: {
    pageTitle: 'Shipping Leads',
    formUrl: 'https://www.df-alliance.com/benefits/shipping-leads',
    leadSubtype: 'Benefit',
  },
  networking: {
    pageTitle: 'Networking',
    formUrl: 'https://www.df-alliance.com/benefits/networking',
    leadSubtype: 'Benefit',
  },
  support: {
    pageTitle: 'Support',
    formUrl: 'https://www.df-alliance.com/benefits/support',
    leadSubtype: 'Benefit',
  },
  paymentProtection: {
    pageTitle: 'Payment Protection',
    formUrl: 'https://www.df-alliance.com/benefits/payment-protection',
    leadSubtype: 'Benefit',
  },
  brandReliability: {
    pageTitle: 'Brand Reliability',
    formUrl: 'https://www.df-alliance.com/benefits/brand-reliability',
    leadSubtype: 'Benefit',
  },
  searatesErp: {
    pageTitle: 'SeaRates ERP',
    formUrl: 'https://www.df-alliance.com/digital-tools/searates-erp',
    leadSubtype: 'DFA ERP',
  },
  cargoesFlow: {
    pageTitle: 'Cargoes Flow',
    formUrl: 'https://www.df-alliance.com/digital-tools/cargoes-flow',
    leadSubtype: 'DFA Cargoes Flow',
  },
};
